import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

interface IFeatureFlags {
  canUsePreview: boolean;
  isSessionReplayEnabled?: boolean;
}

export const useFeatureFlags = (): IFeatureFlags => {
  const {
    userInfo: {
      can_use_preview = false,
      session_replay = false,
    },
  } = useInitialInfoStore();
  return {
    canUsePreview: can_use_preview,
    isSessionReplayEnabled: session_replay,
  };
};
